import React, { useEffect, useState } from "react";
import '../theme/sidenav.css';
import {SidenavState, sidnavStore} from "../api/SidenavStore";
import homeIcon from "../imgs/home-nav.png"
import coin from "../imgs/coin.png"
import newsIcon from "../imgs/news.png"
import distance from "../imgs/distance.png"
import trailer from "../imgs/trailer icon.png"
import right from "../imgs/right-arrow.png"
import {Link} from "react-router-dom";
import westernIcon from "./assets/Western-Logo-WHITE.png"
import { IonItem } from "@ionic/react";
import { link } from "fs";
import { ApiService } from "../api/ApiService";
import { useMostUsedPagesStore } from "../components/AppPageTracker";

const Sidenav: React.FC = () => {

    const {open, close}: { open: boolean, close: () => void } = sidnavStore((state: SidenavState) => ({open: state.open, close: state.close}));
    const mostUsedPages: {page: string, count: number}[] = useMostUsedPagesStore().mostUsedPages;
    const [scarcityMode, setScarcityMode] = useState('0');
    const [hasPrePlanned, setHasPrePlanned] = useState(false)

        useEffect(() => {
            ApiService.getUserState('Load', {name: 'scarcityMode', userId: 0}).then(it => setScarcityMode(it.value));
            ApiService.getPreplannedLoads('load').then(it => setHasPrePlanned(!!it?.length)).catch(it => console.log("no preplanneds found"));
        }, [])

    const links = [
        {
            name: 'Home', link: '/home', icon: homeIcon, active: false, children: []
        },
        {
            name: 'Load', link: '/load', icon: trailer, active: false, children: [
                {name: 'Current Load', link: '/currentload', active: false},
                {name: scarcityMode === '1' && hasPrePlanned ? "Preplanned" : "Load Selection", link: scarcityMode === '1' && hasPrePlanned ? "/preplanned" : "/loadselection", active: false},
                {name: 'Load History', link: '/loadhistory', active: false},
            ]
        },
        {
            name: 'Trip', link: '/trip', icon: distance, active: false, children: [
                {name: 'Trailer Tracking', link: '/trailertracking', active: false},
                {name: 'Tarp Pay', link: '/photoupload', active: false},
                {name: 'Vehicle Inspection', link: '/leasepurchase', active: false},
                {name: 'Trailer ID Photos', link: '/traileridphotos', active: false},
            ]
        },
        {
            name: 'Pay', link: '/money', icon: coin, active: false, children: [
                {name: 'Settlements', link: '/settlements', active: false},
                {name: 'Deferment', link: '/deferment', active: false},
                {name: 'Fuel Receipts', link: '/fuelreceipts', active: false},
                {name: 'Payroll F.A.Q.', link: '/payrollfaq', active: false}
            ]
        },
        {
            name: 'Docs', link: '/docs', icon: newsIcon, active: false, children: [
                {name: 'Safety', link: '/safety', active: false},
                {name: 'Maintenance', link: '/maintenancevids', active: false},
                {name: 'Benefits', link: '/benefits', active: false},
                {name: 'Permits', link: '/permits', active: false},
                {name: 'Contracts', link: '/contracts', active: false},
                {name: 'Accident Information', link: '/accidentinfo', active: false}
            ]
        }
    ];

    links.forEach(parent => {
        const currentPage = window.location.href.toLowerCase();
        if (currentPage.match(parent.link)) {
            parent.active = true;
        }
        const activeChild = parent.children.find(child => currentPage.match(child.link));
        if (activeChild) {
            parent.active = true;
            activeChild.active = true;
        }

    });
    if (mostUsedPages.length) {
        const parent = {name: 'Frequently visited', link: '', icon: newsIcon, active: false, children: []};
        const allLinks = links.flatMap(it => it.children);
        mostUsedPages.sort((a, b) => b.count - a.count);
        mostUsedPages.slice(0, 3).forEach(it => {
            const link = it.page.toLowerCase();
            const existingLink = allLinks.find(it => it.link === link);
            if (!existingLink) {
                // @ts-ignore
                parent.children.push({name: it.page.substring(1), link: it.page, active: false});
            } else {
                // @ts-ignore
                parent.children.push(existingLink);
            }
        })
        links.unshift(parent);
    }

    return (
        <div className={`sidenav ${open ? 'sidenav-open' : ''}`} onClick={() => close()}>
            <div className="sidenav-content">
                <div style={{textAlign: "center", borderBottom: "1px #0e375a solid", marginBottom: "10px", background: "#fff"}}>
                    <img className="LP-Icon-Start" style={{maxWidth: "100px", marginTop: "2%"}} src="/assets/logo_lp.png" alt=""/>
                    {/* <span style={{fontSize: "26px", color: "#fff", fontWeight: "600", fontStyle: "italic"}}>LP <span style={{color: "#34aaff"}}>.</span> Pro</span> */}
                </div>
                {links.map(parent => <div key={parent.link} style={{borderBottom: "1px #fff solid", marginBottom: "10px"}}>
                    <Link to={parent.link} style={{ textDecoration: "none"}} id={`${parent.name}Heading`}>
                        <div className={`sidenav-link ${parent.active ? 'active' : ''}`} id={parent.name}>
                            <img className="sidenav-icon" src={parent.icon} alt={parent.name} id={parent.name}/>
                            <div id={parent.name}>{parent.name}</div>
                            <img src={right} style={{height: "12px", opacity: '50%'}} alt="arrow right"id={parent.name} />
                        </div>
                    </Link>
                    {parent.children.map(it => <div key={it.link}>
                        <Link to={it.link} style={{ textDecoration: "none"}}>
                            <div className={`sidenav-link sidenav-sublink ${it.active ? 'active' : ''}`}>
                            <div style={parent.name === 'Frequently visited' ? {fontWeight: '600'} : {}}>{it.name}</div>
                                <img src={right} style={{height: "10px", opacity: '50%'}} alt="arrow right"/>
                            </div>
                        </Link>
                    </div>)}
                </div>)}
            </div>
        </div>
    )
}
export default Sidenav;
